// ── Voting Player Controller ──────────────────────────────────────────────────

const PLAYER_COLORS = ["#FF00FF", "#00FFFF", "#FFFF00", "#39FF14", "#FF0055", "#FF6B00", "#00FF88", "#FF88FF"];

export default function VotingPlayer({ question, players, selectedVote, result, playerName, onVote }) {
  if (!question) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-[#FFFF00] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col animate-slide-up">
      {/* Question */}
      <div className="text-center mb-6">
        <h2 className="font-heading text-xl text-white leading-tight">{question}</h2>
      </div>

      {/* Player grid */}
      <div className="flex-1 grid grid-cols-2 gap-3">
        {players.filter(p => p !== playerName).map((player, i) => {
          const isSelected = selectedVote === player;
          const votes = result ? (result.vote_counts[player] || 0) : 0;

          return (
            <button
              key={player}
              onClick={() => onVote(player)}
              disabled={selectedVote !== null}
              style={{ backgroundColor: PLAYER_COLORS[i % PLAYER_COLORS.length] }}
              className={[
                "rounded-2xl p-4",
                "flex flex-col items-center justify-center",
                "transition-all active:scale-95",
                isSelected ? "ring-4 ring-white" : "",
                selectedVote !== null && !isSelected ? "opacity-50" : "",
              ].join(" ")}
            >
              <span className="font-bold text-black text-lg mb-1">{player}</span>
              {result && (
                <span className="font-display text-2xl text-black animate-bounce-in">
                  {votes}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {result && (
        <div className="mt-4 text-center animate-bounce-in">
          <p className="font-heading text-[#A1A1AA]">Голоса подсчитаны!</p>
        </div>
      )}
    </div>
  );
}
